module.exports = __webpack_public_path__ + "static/media/android-store.3b31ad3d.png";